export var isFunction = function isFunction(unknown) {
  return typeof unknown === 'function';
};
export var isString = function isString(unknown) {
  return typeof unknown === 'string' || !!unknown && typeof unknown === 'object' && Object.prototype.toString.call(unknown) === '[object String]';
};
export var isDate = function isDate(unknown) {
  return (Object.prototype.toString.call(unknown) === '[object Date]' || unknown instanceof Date) && !isNaN(unknown.valueOf());
};
export var isObject = function isObject(unknown) {
  return (typeof unknown === 'function' || typeof unknown === 'object' && !!unknown) && !Array.isArray(unknown);
};
export var isNode = function isNode(unknown) {
  try {
    Node.prototype.cloneNode.call(unknown, false);
    return true;
  } catch (err) {
    return false;
  }
};
export var isNodeList = function isNodeList(unknown) {
  return NodeList.prototype.isPrototypeOf(unknown);
};
var falsy = /^(?:f(?:alse)?|no?|0+)$/i;
export var BooleanParse = function BooleanParse(val) {
  return !falsy.test(val) && !!val;
};